export default {
  en: {
    'tt-act-labor-guide-hours-diff': 'Act Labor Guide Hours +/-',
    'tt-adj-proj-diff-hours-comp-pct': 'Adj Proj +/- Hours Comp %',
    'tt-adj-theoretical-food-cost-pct-diff': 'Adj Theoretical Food Cost % +/-',
    'tt-all-net-sales-diff-pct': 'All Net Sales +/- %',
    'tt-all-net-sls': 'All Net Sls',
    'tt-avg-check-diff': 'Avg Check +/-',
    'tt-avg-hourly-rate-diff': 'Avg Hourly Rate +/-',
    'tt-canceled-item-amt-comp': 'Canceled Item Amt Comp',
    'tt-canceled-item-cnt-comp-pct': 'Canceled Item Cnt Comp %',
    'tt-canceled-order-amt-comp-pct': 'Canceled Order Amt Comp %',
    'tt-canceled-order-cnt-comp-pct': 'Canceled Order Cnt Comp %',
    'tt-cogs': 'COGS',
    'tt-cogs-diff': 'COGS +/-',
    'tt-cogs-food': 'COGS Food',
    'tt-cogs-food-diff': 'COGS Food +/-',
    'tt-cogs-other': 'COGS Other',
    'tt-cogs-other-diff': 'COGS Other +/-',
    'tt-cogs-paper': 'COGS Paper',
    'tt-cogs-paper-diff': 'COGS Paper +/-',
    'tt-delivery-avg-check-comp-pct': 'Delivery Avg Check Comp %',
    'tt-delivery-net-sales-comp-pct': 'Delivery Net Sales Comp %',
    'tt-delivery-refund-sales-comp-pct': 'Delivery Refund Sales Comp %',
    'tt-delivery-refund-trans-comp-diff': 'Delivery Refund Trans Comp +/-',
    'tt-delivery-trans-comp-diff': 'Delivery Trans Comp +/-',
    'tt-drive-thru-avg-check-comp-pct': 'Drive Thru Avg Check Comp %',
    'tt-drive-thru-net-sales-comp-pct': 'Drive Thru Net Sales Comp %',
    'tt-drive-thru-refund-sales-comp-pct': 'Drive Thru Refund Sales Comp %',
    'tt-drive-thru-refund-trans-comp-diff': 'Drive Thru Refund Trans Comp +/-',
    'tt-drive-thru-trans-comp-pct': 'Drive Thru Trans Comp %',
    'tt-dt-avg-check': 'DT Avg Check',
    'tt-dt-avg-check-diff': 'DT Avg Check +/-',
    'tt-dt-sales-diff-pct': 'DT Sales +/- %',
    'tt-dt-tcs-diff-pct': "DT TC's +/- %",
    'tt-eat-in-avg-check-comp-pct': 'Eat In Avg Check Comp %',
    'tt-eat-in-net-sales-comp-pct': 'Eat In Net Sales Comp %',
    'tt-eat-in-refund-sales-comp-pct': 'Eat In Refund Sales Comp %',
    'tt-eat-in-refund-trans-comp-diff': 'Eat In Refund Trans Comp +/-',
    'tt-eat-in-trans-comp-diff': 'Eat In Trans Comp +/-',
    'tt-food-pct-actual-vs-budget': 'Food % Actual Vs Budget',
    'tt-food-actual-vs-budget': 'Food Actual Vs Budget',
    'tt-food-cost-diff': 'Food Cost +/-',
    'tt-food-var-diff': 'Food Var +/-',
    'tt-food-var-cost-diff': 'Food Var Cost +/-',
    'tt-gap-variance-pct-diff': 'Gap Variance % +/-',
    'tt-hourly-labor-pct-diff': 'Hourly Labor % +/-',
    'tt-hourly-labor-diff-pct': 'Hourly Labor +/- %',
    'tt-hourly-labor-hours-diff-pct': 'Hourly Labor Hours +/- %',
    'tt-kiosk-avg-check-comp-pct': 'Kiosk Avg Check Comp %',
    'tt-kiosk-net-sales-comp-pct': 'Kiosk Net Sales Comp %',
    'tt-kiosk-refund-sales-comp-pct': 'Kiosk Refund Sales Comp %',
    'tt-kiosk-refund-trans-comp-diff': 'Kiosk Refund Trans Comp +/-',
    'tt-kiosk-trans-comp-diff': 'Kiosk Trans Comp +/-',
    'tt-lobby-avg-check': 'Lobby Avg Check',
    'tt-lobby-avg-check-diff': 'Lobby Avg Check +/-',
    'tt-lobby-sales-diff-pct': 'Lobby Sales +/- %',
    'tt-lobby-tcs-diff-pct': "Lobby TC's +/- %",
    'tt-management-labor-diff': 'Management Labor +/-',
    'tt-manager-void-amt-diff': 'Manager Void Amt +/-',
    'tt-manager-void-cnt-comp': 'Manager Void Cnt Comp',
    'tt-mgmt-labor-pct': 'Mgmt Labor %',
    'tt-mobile-delivery-avg-check-comp-pct': 'Mobile Delivery Avg Check Comp %',
    'tt-mobile-delivery-net-sales-comp-pct': 'Mobile Delivery Net Sales Comp %',
    'tt-mobile-delivery-refund-sales-comp-pct': 'Mobile Delivery Refund Sales Comp %',
    'tt-mobile-drive-thru-refund-trans-comp-diff': 'Mobile Drive Thru Refund Trans Comp +/-',
    'tt-mobile-drive-thru-trans-comp-diff': 'Mobile Drive Thru Trans Comp +/-',
    'tt-mobile-take-out-avg-check-comp-pct': 'Mobile Take Out Avg Check Comp %',
    'tt-mobile-take-out-net-sales-comp-pct': 'Mobile Take Out Net Sales Comp %',
    'tt-mobile-take-out-refund-sales-comp-pct': 'Mobile Take Out Refund Sales Comp %',
    'tt-mobile-take-out-refund-trans-comp-diff': 'Mobile Take Out Refund Trans Comp +/-',
    'tt-mobile-take-out-trans-comp-diff': 'Mobile Take Out Trans Comp +/-',
    'tt-net-sales-actual-vs-budget': 'Net Sales Actual Vs Budget',
    'tt-net-sales-comp-pct': 'Net Sales Comp %',
    'tt-other-cost-diff': 'Other Cost +/-',
    'tt-other-var-diff': 'Other Var +/-',
    'tt-other-var-cost-diff': 'Other Var Cost +/-',
    'tt-overring-amt-comp-diff': 'Overring Amt Comp +/-',
    'tt-paper-cost-diff': 'Paper Cost +/-',
    'tt-paper-var-diff': 'Paper Var +/-',
    'tt-paper-var-cost-diff': 'Paper Var Cost +/-',
    'tt-proj-labor-guide-hours': 'Proj Labor Guide Hours',
    'tt-proj-labor-guide-hours-diff': 'Proj Labor Guide Hours +/-',
    'tt-refund-sales-comp-pct': 'Refund Sales Comp %',
    'tt-refund-trans': 'Refund Trans',
    'tt-refund-trans-comp-diff': 'Refund Trans Comp +/-',
    'tt-salaried-labor-diff-pct': 'Salaried Labor +/- %',
    'tt-take-out-avg-check-comp-pct': 'Take Out Avg Check Comp %',
    'tt-take-out-net-sales-comp-pct': 'Take Out Net Sales Comp %',
    'tt-take-out-refund-sales-comp-pct': 'Take Out Refund Sales Comp %',
    'tt-take-out-refund-trans-comp-diff': 'Take Out Refund Trans Comp +/-',
    'tt-take-out-trans-comp-diff': 'Take Out Trans Comp +/-',
    'tt-tc-diff-pct': 'TC +/- %',
    'tt-theoretical-food-cost-pct-diff': 'Theoretical Food Cost % +/-',
    'tt-total-cost-diff': 'Total Cost +/-',
    'tt-total-labor-diff': 'Total Labor +/-',
    'tt-total-labor-pct-actual-vs-budget': 'Total Labor % Actual Vs Budget',
    'tt-total-labor-actual-vs-budget': 'Total Labor Actual Vs Budget',
    'tt-total-labor-cost': 'Total Labor Cost',
    'tt-total-labor-cost-diff': 'Total Labor Cost +/-',
    'tt-total-var-diff': 'Total Var +/-',
    'tt-total-var-cost-diff': 'Total Var Cost +/-',
    'tt-total-waste-diff': 'Total Waste +/-',
    'tt-total-waste-cost-diff': 'Total Waste Cost +/-',
    'tt-training-hours-diff': 'Training Hours +/-',
    'tt-transactions-comp-pct': 'Transactions Comp %',
    'tt-trans-comp-pct': 'Trans Comp %',
    'tt-trans-per-labor-hour-diff': 'Trans / Labor Hour +/-',
  },
  es: {
    'tt-act-labor-guide-hours-diff': 'Horas Guía de Labor Actual +/-',
    'tt-adj-proj-diff-hours-comp-pct': 'Horas Proy Ajust +/- Comp %',
    'tt-adj-theoretical-food-cost-pct-diff': 'Costo Teórico de Alimentos Ajust % +/-',
    'tt-all-net-sales-diff-pct': 'Todas las Ventas Netas +/- %',
    'tt-all-net-sls': 'Todas las Ventas Netas',
    'tt-avg-check-diff': 'Cheque Promedio +/-',
    'tt-avg-hourly-rate-diff': 'Tarifa Promedio Por Hora +/-',
    'tt-canceled-item-amt-comp': 'Monto de Artículo Cancelado Comp',
    'tt-canceled-item-cnt-comp-pct': 'Cnt de Artículo Cancelado Comp %',
    'tt-canceled-order-amt-comp-pct': 'Monto de Orden Cancelada Comp %',
    'tt-canceled-order-cnt-comp-pct': 'Cnt de Orden Cancelada Comp %',
    'tt-cogs': 'COGS',
    'tt-cogs-diff': 'COGS +/-',
    'tt-cogs-food': 'COGS Alimentos',
    'tt-cogs-food-diff': 'COGS Alimentos +/-',
    'tt-cogs-other': 'COGS Otros',
    'tt-cogs-other-diff': 'COGS Otros +/-',
    'tt-cogs-paper': 'COGS Papel',
    'tt-cogs-paper-diff': 'COGS Papel +/-',
    'tt-delivery-avg-check-comp-pct': 'Cheque Promedio de Entrega Comp %',
    'tt-delivery-net-sales-comp-pct': 'Ventas Netas de Entrega Comp %',
    'tt-delivery-refund-sales-comp-pct': 'Ventas de Reembolso de Entrega Comp %',
    'tt-delivery-refund-trans-comp-diff': 'Trans de Reembolso de Entrega Comp +/-',
    'tt-delivery-trans-comp-diff': 'Trans de Entrega Comp +/-',
    'tt-drive-thru-avg-check-comp-pct': 'Cheque Promedio de Autoservicio Comp %',
    'tt-drive-thru-net-sales-comp-pct': 'Ventas Netas de Autoservicio Comp %',
    'tt-drive-thru-refund-sales-comp-pct': 'Ventas de Reembolso de Autoservicio Comp %',
    'tt-drive-thru-refund-trans-comp-diff': 'Trans de Reembolso de Autoservicio Comp +/-',
    'tt-drive-thru-trans-comp-pct': 'Trans de Autoservicio Comp %',
    'tt-dt-avg-check': 'DT Cheque Promedio',
    'tt-dt-avg-check-diff': 'DT Cheque Promedio +/-',
    'tt-dt-sales-diff-pct': 'DT Ventas +/- %',
    'tt-dt-tcs-diff-pct': "DT TC's +/- %",
    'tt-eat-in-avg-check-comp-pct': 'Cheque Promedio de Comer Aquí Comp %',
    'tt-eat-in-net-sales-comp-pct': 'Ventas Netas de Comer Aquí Comp %',
    'tt-eat-in-refund-sales-comp-pct': 'Ventas de Reembolso de Comer Aquí Comp %',
    'tt-eat-in-refund-trans-comp-diff': 'Trans de Reembolso de Comer Aquí Comp +/-',
    'tt-eat-in-trans-comp-diff': 'Trans de Comer Aquí Comp +/-',
    'tt-food-pct-actual-vs-budget': 'Alimentos % Actual Vs Presupuesto',
    'tt-food-actual-vs-budget': 'Alimentos Actual Vs Presupuesto',
    'tt-food-cost-diff': 'Costo de Alimentos +/-',
    'tt-food-var-diff': 'Varianza de Alimentos +/-',
    'tt-food-var-cost-diff': 'Costo de Varianza de Alimentos +/-',
    'tt-gap-variance-pct-diff': 'Varianza de Brecha % +/-',
    'tt-hourly-labor-pct-diff': 'Labor Por Hora % +/-',
    'tt-hourly-labor-diff-pct': 'Labor Por Hora +/- %',
    'tt-hourly-labor-hours-diff-pct': 'Horas de Labor Por Hora +/- %',
    'tt-kiosk-avg-check-comp-pct': 'Cheque Promedio de Kiosco Comp %',
    'tt-kiosk-net-sales-comp-pct': 'Ventas Netas de Kiosco Comp %',
    'tt-kiosk-refund-sales-comp-pct': 'Ventas de Reembolso de Kiosco Comp %',
    'tt-kiosk-refund-trans-comp-diff': 'Trans de Reembolso de Kiosco Comp +/-',
    'tt-kiosk-trans-comp-diff': 'Trans de Kiosco Comp +/-',
    'tt-lobby-avg-check': 'Lobby Cheque Promedio',
    'tt-lobby-avg-check-diff': 'Lobby Cheque Promedio +/-',
    'tt-lobby-sales-diff-pct': 'Lobby Ventas +/- %',
    'tt-lobby-tcs-diff-pct': "Lobby TC's +/- %",
    'tt-management-labor-diff': 'Labor Gerencial +/-',
    'tt-manager-void-amt-diff': 'Monto de Anulación de Gerente +/-',
    'tt-manager-void-cnt-comp': 'Cnt de Anulación de Gerente Comp',
    'tt-mgmt-labor-pct': 'Labor Gerencial %',
    'tt-mobile-delivery-avg-check-comp-pct': 'Cheque Promedio de Entrega Móvil Comp %',
    'tt-mobile-delivery-net-sales-comp-pct': 'Ventas Netas de Entrega Móvil Comp %',
    'tt-mobile-delivery-refund-sales-comp-pct': 'Ventas de Reembolso de Entrega Móvil Comp %',
    'tt-mobile-drive-thru-refund-trans-comp-diff': 'Trans de Reembolso de Autoservicio Móvil Comp +/-',
    'tt-mobile-drive-thru-trans-comp-diff': 'Trans de Autoservicio Móvil Comp +/-',
    'tt-mobile-take-out-avg-check-comp-pct': 'Cheque Promedio de Para Llevar Móvil Comp %',
    'tt-mobile-take-out-net-sales-comp-pct': 'Ventas Netas de Para Llevar Móvil Comp %',
    'tt-mobile-take-out-refund-sales-comp-pct': 'Ventas de Reembolso de Para Llevar Móvil Comp %',
    'tt-mobile-take-out-refund-trans-comp-diff': 'Trans de Reembolso de Para Llevar Móvil Comp +/-',
    'tt-mobile-take-out-trans-comp-diff': 'Trans de Para Llevar Móvil Comp +/-',
    'tt-net-sales-actual-vs-budget': 'Ventas Netas Actual Vs Presupuesto',
    'tt-net-sales-comp-pct': 'Ventas Netas Comp %',
    'tt-other-cost-diff': 'Costo de Otros +/-',
    'tt-other-var-diff': 'Varianza de Otros +/-',
    'tt-other-var-cost-diff': 'Costo de Varianza de Otros +/-',
    'tt-overring-amt-comp-diff': 'Monto de Sobreregistro Comp +/-',
    'tt-paper-cost-diff': 'Costo de Papel +/-',
    'tt-paper-var-diff': 'Varianza de Papel +/-',
    'tt-paper-var-cost-diff': 'Costo de Varianza de Papel +/-',
    'tt-proj-labor-guide-hours': 'Horas Guía de Labor Proyectadas',
    'tt-proj-labor-guide-hours-diff': 'Horas Guía de Labor Proyectadas +/-',
    'tt-refund-sales-comp-pct': 'Ventas de Reembolso Comp %',
    'tt-refund-trans': 'Trans de Reembolso',
    'tt-refund-trans-comp-diff': 'Trans de Reembolso Comp +/-',
    'tt-salaried-labor-diff-pct': 'Labor Asalariado +/- %',
    'tt-take-out-avg-check-comp-pct': 'Cheque Promedio de Para Llevar Comp %',
    'tt-take-out-net-sales-comp-pct': 'Ventas Netas de Para Llevar Comp %',
    'tt-take-out-refund-sales-comp-pct': 'Ventas de Reembolso de Para Llevar Comp %',
    'tt-take-out-refund-trans-comp-diff': 'Trans de Reembolso de Para Llevar Comp +/-',
    'tt-take-out-trans-comp-diff': 'Trans de Para Llevar Comp +/-',
    'tt-tc-diff-pct': 'TC +/- %',
    'tt-theoretical-food-cost-pct-diff': 'Costo Teórico de Alimentos % +/-',
    'tt-total-cost-diff': 'Costo Total +/-',
    'tt-total-labor-diff': 'Labor Total +/-',
    'tt-total-labor-pct-actual-vs-budget': 'Labor Total % Actual Vs Presupuesto',
    'tt-total-labor-actual-vs-budget': 'Labor Total Actual Vs Presupuesto',
    'tt-total-labor-cost': 'Costo de Labor Total',
    'tt-total-labor-cost-diff': 'Costo de Labor Total +/-',
    'tt-total-var-diff': 'Varianza Total +/-',
    'tt-total-var-cost-diff': 'Costo de Varianza Total +/-',
    'tt-total-waste-diff': 'Desperdicio Total +/-',
    'tt-total-waste-cost-diff': 'Costo de Desperdicio Total +/-',
    'tt-training-hours-diff': 'Horas de Capacitación +/-',
    'tt-transactions-comp-pct': 'Transacciones Comp %',
    'tt-trans-comp-pct': 'Trans Comp %',
    'tt-trans-per-labor-hour-diff': 'Trans / Hora de Labor +/-',
  },
};
